<div class="container-fluid main-page main-page-padding">
  <div class="top-nav-bar-container">
    <div class="top-nav-bar">
      <span class="title"> My Account</span>
    </div>
  </div>
  <div class="page-content-widgets">
    <div class="sections-wrapper">
      <div class="section" *ngIf="buyer">
        <app-account-details [buyer]="buyer" [isNotInBranch]="isNotInBranch"></app-account-details>
      </div>
      <div class="divider"></div>
      <div class="section">
        <app-device-details></app-device-details>
      </div>
      <div class="divider"></div>
      <div class="section actions">
         <button class="nav-button" (click)="clockAction()" *ngIf="!isNotInBranch && canClock">
          <img src="../../assets/icons/clock-icon.svg" class="clock-img" alt="CheckIn" />
          <span>Clock In/Out</span>
        </button>
         <button class="nav-button" (click)="checkIn()" *ngIf="!isNotInBranch">
          <img src="../../assets/icons/icon-qr.svg" alt="CheckIn" />
          <span>RM Check-In</span>
        </button>
        <button *ngIf="inTheGame" class="nav-button" (click)="seeWhatIveWon()">
          <img src="../../assets/icons/buttons/medal.svg" alt="Trophy Cabinet" />
          <span>Trophy Cabinet</span>
        </button>
        <button class="nav-button" (click)="playTheGame()" *ngIf="canPlayGames">
          <img src="../../assets/icons/buttons/dice.png" alt="Daily Game" />
          <span>Daily Game</span>
        </button>
        <button class="nav-button" (click)="logout()">
          <img src="../../assets/icons/buttons/circle-arrow.svg" alt="Sign Out" />
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="text-center">
    <app-loading-wbac-animation></app-loading-wbac-animation>
  </div>
</div>